const USER_TYPE = {
  Personal: 1,
  Company: 2,
};

export default USER_TYPE;
